
<template>

  <div class="ui segments" :class="[displayEhdaa && 'big']">

    <!-- Ehdaa (for display in khatma view) -->
    <div v-if="displayEhdaa" class="ui center aligned segment">
      <span class="ui almarai primary text">
        تهدى هذه الختمة إلى
        <br>
        <span class="ui almarai grey text">
          {{ khatma.ehdaa }}
        </span>
      </span>
    </div>

    <!-- Khatma completions -->
    <div class="ui center aligned segment">
      <span class="ui almarai text" :class="[!khatma.concluded ? 'primary' : 'secondary']">
        تم إكمال {{ khatma.completed }} {{ times }}
      </span>
    </div>

    <!-- Current khatma progress -->
    <div class="ui center aligned segment" v-if="!khatma.concluded">

      <div class="ui english primary progress" :class="khatma.id">

        <div class="bar" />
        <div class="almarai primary label">
          <span class="ui almarai primary text">%الختمة الحالية: {{ percentage }}</span>
        </div>

      </div>

    </div>

  </div>

</template>

<script>
export default {

  name: 'Counter',
  props: {

    khatma: Object,
    displayEhdaa: Boolean

  },
  computed: {

    times() {

      if (this.khatma.completed <= 1 || this.khatma.completed > 10)
        return 'ختمة';

      else
        return 'ختمات';

    },

    percentage() {

      return (this.khatma.progress / 240 * 100).toFixed(1);

    }

  },
  watch: {

    percentage(newPercentage) {

      $(`.ui.progress.${this.khatma.id}`).progress('set percent', newPercentage);

    }

  },
  mounted() {

    $(`.ui.progress.${this.khatma.id}`).progress({

      percent: this.percentage,

      autoSuccess: false,
      showActivity: false

    });

  }

}
</script>
